/**
 * Check if user has a valid license based on licenseExpiresAt date
 * @param licenseExpiresAt - License expiration date from JWT token
 * @returns true if license exists and is not expired, false otherwise
 */
export const hasValidLicense = (licenseExpiresAt?: Date): boolean => {
  if (!licenseExpiresAt) {
    return false;
  }

  const now = new Date();
  const expirationDate = licenseExpiresAt instanceof Date
    ? licenseExpiresAt
    : new Date(licenseExpiresAt);

  return expirationDate >= now;
};

